import "./marketing.css"
import React from "react"
import { createRoot } from "react-dom/client"
import App from "../marketing/App.jsx"

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("marketing-root")
  if (container) {
    const priceCents = Number(container.dataset.priceCents) || 0
    const page = container.dataset.page || "home"
    const promoCode = container.dataset.promoCode || null
    const spotsRemaining = container.dataset.spotsRemaining !== undefined
      ? Number(container.dataset.spotsRemaining)
      : null
    const spotsTotal = container.dataset.spotsTotal !== undefined
      ? Number(container.dataset.spotsTotal)
      : null
    const appStoreUrl = container.dataset.appStoreUrl || null
    const translations = JSON.parse(container.dataset.translations || "{}")
    const root = createRoot(container)
    root.render(
      <App
        priceCents={priceCents}
        page={page}
        promoCode={promoCode}
        spotsRemaining={spotsRemaining}
        spotsTotal={spotsTotal}
        appStoreUrl={appStoreUrl}
        translations={translations}
      />
    )
  }
})
